export function getVolleyballStatisticHeader(light?: boolean) {
  return [
    {
      id: 'gamesCount',
      title: 'Матчи'
    },
    {
      id: 'wonGamesCount',
      title: 'Победы'
    },
    {
      id: 'tournamentPoints',
      title: 'Турнирные очки'
    },
    {
      id: 'points',
      title: 'Очки'
    },
    {
      id: 'attackSpikes',
      title: 'Атаки'
    },
    {
      id: 'stuffBlocks',
      title: 'Блоки'
    },
    {
      id: 'serveAces',
      title: 'Эйсы'
    },
    ...(!light
        ? [
          {
            id: 'excellentServeReceives',
            title: 'Приемы подачи'
          },
          {
            id: 'excellentReceives',
            title: 'Приемы'
          },
        ]
        : []
    ),
    {
      id: 'attackPercent',
      title: '% успешных атак'
    },
    {
      id: 'acePercent',
      title: '% эйсов'
    },
    {
      id: 'blockPercent',
      title: '% успешных блоков'
    },
    ...(!light
        ? [
          {
            id: 'serveReceivePercent',
            title: '% успешных приемов подачи'
          },
          {
            id: 'receivePercent',
            title: '% успешных приемов'
          }
        ]
        : []
    ),
  ];
}
